"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FullAlign = _styledComponents["default"].div(_templateObject());

var FullAlignContainer = function FullAlignContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(FullAlign, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, children));
};

FullAlignContainer.propTypes = {
  children: _propTypes["default"].node
};
var _default = FullAlignContainer;
exports["default"] = _default;